<template>
  <v-container>
    <div class="ticket">
      <img :src="compt.business_logo" alt="Logo" />
      <p class="centered">
        {{ new Date(compt.created_at).toLocaleDateString() }} <br />
        {{ compt.order_id }}
      </p>
      <table>
        <thead>
          <tr>
            <th class="text-body-2 px-1">Name</th>
            <th class="text-body-2">Qty</th>
            <th class="text-body-2 mx-1">Unit price</th>
            <th class="text-body-2">price</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in it" :key="item.pid">
            <td>{{ item.product }}</td>
            <td>{{ item.qty }}</td>
            <td class="px-1">N{{ item.amount }},</td>
            <td>N{{ JSON.parse(item.amount) * JSON.parse(item.qty) }}.00</td>
          </tr>
        </tbody>
      </table>
      <v-list-item dense class="text-caption">
        <v-list-item-title class="text-caption">
          <span>Cash Tendered</span>
        </v-list-item-title>
        <v-list-item-title class="text-caption">
          <span>N{{ compt.amount_paid }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item dense class="text-caption">
        <v-list-item-title>
          <span>Balance Amount</span>
        </v-list-item-title>
        <v-list-item-title class="text-caption">
          <span>N{{ compt.total_amount - compt.amount_paid }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item dense class="text-caption">
        <v-list-item-title>
          <span>Customer Name</span>
        </v-list-item-title>
        <v-list-item-title class="text-caption">
          <span>{{ compt.customer_name }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item dense class="text-caption">
        <v-list-item-title class="text-caption">
          <span>Payment Method</span>
        </v-list-item-title>
        <v-list-item-title class="text-caption">
          <span>{{ compt.payment_method }}</span>
        </v-list-item-title>
      </v-list-item>

      <v-list-item dense class="text-caption">
        <v-list-item-title class="text-caption">
          <span>Sale Made By</span>
        </v-list-item-title>
        <v-list-item-title class="text-caption">
          <span>{{ compt.staff_name }}</span>
        </v-list-item-title>
      </v-list-item>

      <span class="text-body-2">{{ compt.business_name }}</span>
      <p class="text-body-2 mt-0">Thanks for your patronage</p>
    </div>
    <button id="btnPrint" class="hidden-print" @click="print">Print</button>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    isLoading: false,
    items: [],
    model: null,
    step: 1,
    search: null,
    added: [],
    exDate: "",
    discount: 0,
    method: ["Bank transfer/ Mobile Mobile Money", "POS", "Cash"],
    totalSum: 0,
    count: 1,
    newC: false,
    existC: false,
    form: {
      name: "",
      paid: "",
      payable: "",
    },
    names: [],
    compt: [],
    it: [],
    tr: "",
    loaderC: false,
    output: "receipt.pdf",
    myArr: [],

    msg: "testing....................",
    printCharacteristic: null,
    isMobile: true,
  }),

  methods: {
    print() {
      navigator.bluetooth
        .requestDevice(
          {
            filters: [
              {
                name: "BlueTooth Printer",
                services: ["000018f0-0000-1000-8000-00805f9b34fb"],
              },
            ],
          },
          {
            optionalServices: ["00002af1-0000-1000-8000-00805f9b34fb"],
          }
        )
        .then((device) => {
          console.log("device", device);
          if (device.gatt.connected) {
            device.gatt.disconnect();
          }
          console.log("connect");
          return this.connect(device);
        })
        .catch(this.handleError);
    },
    connect(device) {
      const self = this;
      device.addEventListener("gattserverdisconnected", this.onDisconnected);
      return device.gatt
        .connect()
        .then((server) =>
          server.getPrimaryService("000018f0-0000-1000-8000-00805f9b34fb")
        )
        .then((service) =>
          service.getCharacteristic("00002af1-0000-1000-8000-00805f9b34fb")
        )
        .then((characteristic) => {
          console.log("characteristic", characteristic);
          self.printCharacteristic = characteristic;
          self.sendTextData(device);
        })
        .catch((error) => {
          this.handleError(error, device);
        });
    },
    handleError(error, device) {
      console.error("handleError => error", error);
      if (device != null) {
        device.gatt.disconnect();
      }
      let erro = JSON.stringify({
        code: error.code,
        message: error.message,
        name: error.name,
      });
      console.log("handleError => erro", erro);
      if (error.code !== 8) {
        this.$q.notify("Could not connect with the printer. Try it again");
      }
    },
    getBytes(text) {
      console.log("text", text);
      let br = "\u000A\u000D";
      text = text === undefined ? br : text;
      let replaced = this.$languages.replace(text);
      console.log("replaced", replaced);
      let bytes = new TextEncoder("utf-8").encode(replaced + br);
      console.log("bytes", bytes);
      return bytes;
    },
    addText(arrayText) {
      let text = this.msg;
      arrayText.push(text);
      if (this.isMobile) {
        while (text.length >= 20) {
          let text2 = text.substring(20);
          arrayText.push(text2);
          text = text2;
        }
      }
    },
    sendTextData(device) {
      let arrayText = [];
      this.addText(arrayText);
      console.log("sendTextData => arrayText", arrayText);
      this.loop(0, arrayText, device);
    },
    loop(i, arrayText, device) {
      let arrayBytes = this.getBytes(arrayText[i]);
      this.write(device, arrayBytes, () => {
        i++;
        if (i < arrayText.length) {
          this.loop(i, arrayText, device);
        } else {
          let arrayBytes = this.getBytes();
          this.write(device, arrayBytes, () => {
            device.gatt.disconnect();
          });
        }
      });
    },
    write(device, array, callback) {
      this.printCharacteristic
        .writeValue(array)
        .then(() => {
          console.log("Printed Array: " + array.length);
          setTimeout(() => {
            if (callback) {
              callback();
            }
          }, 250);
        })
        .catch((error) => {
          this.handleError(error, device);
        });
    },

    back() {
      this.$router.back();
    },
    printr() {
      window.setTimeout(() => {
        window.focus();
        window.print();
      }, 100);
    },

    comp() {
      this.loaderC = true;
      const data = {
        id: this.$route.params.id,
      };
      fetch(
        "https://receipt.drecsoft.com/api/v1/sales/sale-details",

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          let docs = response.data;
          this.compt = docs.sales;
          docs.sales_products.forEach((element) => {
            let data = {
              amount: element.amount,
              qty: element.qty,
              product: element.product?.name,
            };
            this.it.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
          this.loaderC = false;
        });

      console.log(">>>>>>>>");
    },
  },

  created() {
    this.comp();
  },

  computed: {
    ...mapGetters(["getUser", "currentUser", "getCustomers"]),

    sum() {
      return this.total - this.discount;
    },
    bal() {
      return this.sum - this.form.paid;
    },
    lg() {
      return this.it.reduce(
        (acc, item) => JSON.parse(acc) + JSON.parse(item.qty),
        0
      );
    },
  },
};
</script>

<style type="text/css" media="print" scoped>
body {
  visibility: hidden;
}
.noprintarea {
  visibility: hidden;
  display: none;
}
.noprintcontent {
  visibility: hidden;
}
.print {
  visibility: visible;
  display: block;
}
.custom_bg {
  background: #f6f7ff;
  height: 100%;
}

.scroll {
  overflow-y: scroll;
}

td,
th,
tr,
table {
  border-top: 1px solid black;
  border-collapse: collapse;
}

.centered {
  text-align: center;
  align-content: center;
}

.ticket {
  width: 155px;
  max-width: 155px;
}

img {
  max-width: inherit;
  width: inherit;
}

@media print {
  .hidden-print,
  .hidden-print * {
    display: none !important;
  }
}
</style>
